// sim环境不区分 域名，使用envTag区分
const envTag = window.location.host.split('.')[0]
const baseApi = `//${envTag}.rlab.sim.intra.xiaojukeji.com/b-api`

export default {
  NODE_ENV: process.env.NODE_ENV,
  LOGIN_URL: 'https://page.didiglobal.com/public-biz/pc-login/3.0.1/index.html',
  BASE_API: baseApi,
}
